import { fetchV1 } from 'helpers/fetch.js';
import { toQueryString } from 'helpers/api.js';

export default {
  getBrandHubs(id, filter) {
    return fetchV1.get(`/brands/${id}/hubs?${toQueryString(filter)}`);
  },
};
